/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_P2_BeforeInputs */

const tr_hakkimizda_s4_p2_before = /** @type {(inputs: Hakkimizda_S4_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüzel kimlik ve iletişim bilgileri için`)
};

const en_hakkimizda_s4_p2_before = /** @type {(inputs: Hakkimizda_S4_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For legal identity and contact details, please see our`)
};

const de_hakkimizda_s4_p2_before = /** @type {(inputs: Hakkimizda_S4_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliche Angaben und Kontaktdaten finden Sie auf unserer Seite`)
};

const ru_hakkimizda_s4_p2_before = /** @type {(inputs: Hakkimizda_S4_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридические данные и контактную информацию можно посмотреть на нашей странице`)
};

/**
* | output |
* | --- |
* | "For legal identity and contact details, please see our" |
*
* @param {Hakkimizda_S4_P2_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_p2_before = /** @type {((inputs?: Hakkimizda_S4_P2_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_P2_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_p2_before(inputs)
	if (locale === "de") return de_hakkimizda_s4_p2_before(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_p2_before(inputs)
	return tr_hakkimizda_s4_p2_before(inputs)
});